document.addEventListener('DOMContentLoaded', () => {
    // Get all parent trigger elements
    const parentTriggers = document.querySelectorAll('.link-card');

    parentTriggers.forEach(trigger => {
        const targetElement = trigger.querySelector('.rte');
        const contentElement = trigger.querySelector('.rte p'); // Assumes .content is a descendant of .hover-parent-trigger

        if (!targetElement || !contentElement) {
            console.warn('Could not find .animated-div or .content for a .hover-parent-trigger element:', trigger);
            return; // Skip this trigger if necessary elements are missing
        }

        let originalHeight = 0;

        // Function to calculate and store the original height for THIS specific instance
        function calculateOriginalHeight() {
            // Temporarily make it visible to measure scrollHeight of the content
            const previousHeight = targetElement.style.height; // Store current height
            const previousVisibility = targetElement.style.visibility;
            const previousPosition = targetElement.style.position;

            targetElement.style.height = 'auto';
            targetElement.style.visibility = 'hidden';
            targetElement.style.position = 'absolute';

            originalHeight = contentElement.offsetHeight;

            // Reset styles
            targetElement.style.height = previousHeight === '0px' || previousHeight === '' ? '0' : originalHeight + 'px'; // Restore if it was open
            targetElement.style.visibility = previousVisibility;
            targetElement.style.position = previousPosition;

            // If it was closed initially, ensure it's set back to 0 after measurement
            if (previousHeight === '0px' || previousHeight === '') {
                targetElement.style.height = '0';
            }
        }

        // Calculate initial height
        calculateOriginalHeight();

        // Event listener for mouse entering THIS trigger element
        trigger.addEventListener('mouseenter', () => {
            if (originalHeight > 0) {
                targetElement.style.height = originalHeight + 'px';
            }
        });

        // Event listener for mouse leaving THIS trigger element
        trigger.addEventListener('mouseleave', () => {
            targetElement.style.height = '0';
        });

        // Store a reference to the recalculate function for the resize handler
        // or make originalHeight accessible in a way the resize handler can use for THIS specific element.
        // For simplicity, we'll just recalculate and apply if open.
        // A more robust solution might involve storing state or using data attributes.
        targetElement._calculateOriginalHeight = calculateOriginalHeight; // Storing for resize
        targetElement._originalHeight = () => originalHeight; // Getter for current original height
    });


    // Recalculate on window resize for all instances
    window.addEventListener('resize', () => {
        parentTriggers.forEach(trigger => {
            const targetElement = trigger.querySelector('.animated-div');
            if (targetElement && typeof targetElement._calculateOriginalHeight === 'function') {
                const wasOpen = targetElement.style.height !== '0px' && targetElement.style.height !== '';
                targetElement._calculateOriginalHeight(); // Recalculate
                if (wasOpen) {
                    targetElement.style.height = targetElement._originalHeight() + 'px'; // Re-apply if it was open
                }
            }
        });
    });
});